import { DEFAULT_THEME_COLORS } from '@magnetar/admin-api-interfaces'

export { DEFAULT_THEME_COLORS }

// Overrides only the color fields with the defaults, leaving every other field
// (is_show_header, is_active, ...) untouched.
export function resetThemeColorsToDefault<T extends Record<string, unknown>>(values: T): T {
  return { ...values, ...DEFAULT_THEME_COLORS } as T
}
